import React from 'react';
import Draggable from 'react-draggable';
import properties from '../../../constants/Properties';
import audioEditorUtils from '../utils/AudioEditorUtils';
import mouseUtils from '../../utils/MouseUtils';
import { selectElement, changeElementPosition, setMarkerPosition, deleteItem } from '../../../actions/AudioEditorActions';
import timelineDragManager from '../utils/TimelineDragManager';
import saveManager from '../../utils/SaveManager';
import animator from '../../utils/Animator';
import { AudioGraph } from '../../audioEditor/menus/AudioGraph';
import textSizeUtils from '../../utils/TextSizeUtils';
import hoverManager from '../../utils/HoverManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import audioVolumeUtils from '../../utils/AudioVolumeUtils';
import playController from '../../utils/PlayController';
import platformDetection from '../../utils/PlatformDetection';
import locales from '../../../locales/LocalesManager';
import { setShortcutsTarget } from '../../../actions/CurrentSlideActions';

const ControlPoint = React.createClass({
    getInitialState () {
        return {
            isThumbOver: false,
            isThumbActive: false
        };
    },
    componentDidMount() {
        if (this.props.setRightArrowUpdater)
            this.props.setRightArrowUpdater(this.updateRightArrow);
    },
    onThumbMouseIn () {
        if (!audioEditorUtils.isControlPointAction) {
            if (this.props.index == 0)
                hoverManager.show(this.refs.thumb, 'audioLeftTrim');
            else
                hoverManager.show(this.refs.thumb, 'audioRightTrim');
        }

        this.setState({
                    isThumbOver: true
        });
    },
    onThumbMouseOut () {
        hoverManager.hide();

        this.setState({
            isThumbOver: false
        });
    },
    onMouseDown(e) {
        saveManager.isContentChanged(true);
        hoverManager.hide();
        audioEditorUtils.isControlPointAction = true;

        var touchPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            startClientX: touchPosition.x,
            isThumbActive: true
        });
    },
    onMouseMove(e) {
        this.updateProperties(e);
    },
    onMouseUp(e) {
        this.setState({
            isThumbActive: false
        });

        playController.getOldScrollPosition();

        setTimeout(function() {this.updateProperties(e, true)}.bind(this), 10);
    },
    updateProperties(e, isEndAction = false) {
        var touchPosition = mouseUtils.getTouchPosition(e);
        var offsetX = touchPosition.x - this.state.startClientX;
        var newProperties;

        console.log(offsetX);

        if (this.props.updateSize)
            newProperties = this.props.updateSize(offsetX, this.props.index, isEndAction);

        if (this.props.index == 1 && !isEndAction && newProperties) { // right arrow
            this.refs.thumb.style.left = (newProperties.width - properties.ARROW_SIZE) + 'px';
        }
    },
    onKeyDown(e) {
        if (e.keyCode != 37 && e.keyCode != 39)
            return;

        var isEndAction = true;
        var offsetX = 2;

        if (e.keyCode == 37) // Left Key
            offsetX = - offsetX;

        saveManager.isContentChanged(true);
        playController.getOldScrollPosition();

        this.props.initStateForControlPointKeyHanlder();

        setTimeout(function() {
            var newProperties;

            if (this.props.updateSize)
                newProperties = this.props.updateSize(offsetX, this.props.index, isEndAction);

            if (this.props.index == 1 && !isEndAction && newProperties) { // right arrow
                this.refs.thumb.style.left = (newProperties.width - properties.ARROW_SIZE) + 'px';
            }

        }.bind(this), 10);
    },
    updateRightArrow(width) {
        if (this.refs.thumb)
            this.refs.thumb.style.left = (width - properties.ARROW_SIZE) + 'px';
    },
    render() {
        if (!this.props.showControlPoint)
            return (<div/>);

        var height = audioToolUtils.timelineHeight();
        var leftPos = 0;
        var iconSrc = 'fa fa-angle-left fa-2x';
        var iconColor = 'white';

        if (this.props.index == 1) {
            leftPos = this.props.trackWidth - properties.ARROW_SIZE;
            iconSrc = 'fa fa-angle-right fa-2x';
        }

        var menuStyle  = {
            position: 'absolute',
            left: leftPos,
            top: 0,
            width: properties.ARROW_SIZE,
            height: '100%',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none'
        };

        if (this.state.isThumbOver || this.state.isThumbActive) {
            iconColor = 'black';
        }

        var lineStyle  = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: properties.ARROW_SIZE,
            height,
            background: 'black',
            opacity: 0.25,
            display: 'block'
        };

        var iconWidth = 12;
        var iconHeight = 32;
        const arrowIconStyle = {
            position: 'absolute',
            top: lineStyle.height / 2 - iconHeight / 2,
            left: lineStyle.width / 2 - iconWidth / 2,
            color: iconColor
        };

        var ariaLabelValue;

        if (this.props.index == 0)
            ariaLabelValue = locales.getCaption('audioLeftTrim', 'hover');
        else
            ariaLabelValue = locales.getCaption('audioRightTrim', 'hover');

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <button aria-label={ariaLabelValue} ref='thumb' style={menuStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}>
                    <span style={lineStyle}/>
                    <i style={arrowIconStyle} className={iconSrc}></i>
                </button>
            </Draggable>
        );
    }
});

export const AudioItemRenderer = React.createClass({
    getInitialState () {
        this.checkFocus();

        return {
            canvasWidth: -1
        };
    },
    checkFocus() {
        setTimeout(function() {
            if (mouseUtils.isFirstMarkerFocus) {
                mouseUtils.isFirstMarkerFocus = false;
                this.props.dispatch(setShortcutsTarget(true));
            }
        }.bind(this), 10);
    },
    onMouseIn(e) {
        hoverManager.show(this.refs.waveform, this.props.audio.title, 'top', true, e.clientX);
    },
    onMouseOut () {
        hoverManager.hide();
    },
    getPosition(position) {
        return Number(position.substring(0, position.length - 2));
    },
    isInactiveArea(e) {
        if (e.nativeEvent.target.className.indexOf('inactiveArea') != -1)
            return true;
        else
            return false;
    },
    onMouseDown(e) {
        if (this.isInactiveArea(e))
            return;

        saveManager.isContentChanged(true);
        var left = audioEditorUtils.getItemPosition(this.props.audio.left);
        var durationWidth = audioEditorUtils.getSlideWidth(this.props.audio.duration);

        this.setState({
            startLeftPosition: left,
            startWidth: durationWidth
        });

        if (!audioEditorUtils.isControlPointAction && !audioEditorUtils.isVolumeAction) {
            if (timelineDragManager.isMultipleSelection(this.props.audio.uuid))
                timelineDragManager.startBlock(this.props.windowHeight, mouseUtils.getTouchPosition(e).y, this.props.dispatch);
            else {
                timelineDragManager.resetMultipleSelection();
                timelineDragManager.createClone(this.refs.clone, this.props.windowHeight, left, mouseUtils.getTouchPosition(e).y, durationWidth);
            }
        }
    },
    onMouseMove(e, coreEvent) {
        if (audioEditorUtils.isControlPointAction || audioEditorUtils.isVolumeAction)
            return;

        if (timelineDragManager.isMultipleSelection(this.props.audio.uuid))
            timelineDragManager.moveBlockWithOffset(coreEvent.lastX, coreEvent.lastY, this.props.audio.uuid);
        else
            timelineDragManager.move(coreEvent.lastX, coreEvent.lastY, e);
    },
    onMouseUp(e, coreEvent) {
        if (audioEditorUtils.isControlPointAction || audioEditorUtils.isVolumeAction) {
            audioEditorUtils.isControlPointAction = false;
            audioEditorUtils.isVolumeAction = false;
            return;
        }

        audioEditorUtils.isControlPointAction = false;
        audioEditorUtils.isVolumeAction = false;

        if (timelineDragManager.isMultipleSelection(this.props.audio.uuid)) {
            saveManager.isContentChanged(true);
            playController.getOldScrollPosition();
            timelineDragManager.endBlock(coreEvent.lastX, coreEvent.lastY, this.props.audio.uuid);
        } else {
            timelineDragManager.resetMultipleSelection();

            var properties = {};
            var audio = Object.assign({}, this.props.audio);

            audio.showControlPoint = true;
            properties.audio = audio;
            properties.startIndex = this.props.index;

            saveManager.isContentChanged(true);
            playController.getOldScrollPosition();

            setTimeout(function () {
                if (!this.props.audio.showControlPoint)
                    this.props.dispatch(selectElement(this.props.audio.uuid, true));
            }.bind(this), 5);

            setTimeout(function () {
                timelineDragManager.removeClone(this.props.dispatch, properties);
            }.bind(this), 10);
        }
    },
    initStateForControlPointKeyHanlder() {
        var left = audioEditorUtils.getItemPosition(this.props.audio.left);
        var durationWidth = audioEditorUtils.getSlideWidth(this.props.audio.duration);

        this.setState({
            startLeftPosition: left,
            startWidth: durationWidth
        });
    },
    updateSize(xOffset, arrow, isEndAction = false) {
        var newProperties = this.getCorrectPosition(xOffset, arrow);
        var titleWidth = this.getTextWidth(newProperties.width);
        saveManager.isContentChanged(true);

        if (isEndAction) {
            var propertiesObject = {};
            var audio = Object.assign({}, this.props.audio);

            if (arrow == 0 || newProperties.updateLeft)
                audio.left = audioEditorUtils.getItemTimePosition(newProperties.x);

            if (arrow == 0)
                audio.inPoint = newProperties.inPoint;
            else
                audio.outPoint = newProperties.outPoint;

            audio.duration = audioEditorUtils.getItemTimePosition(newProperties.width);

            propertiesObject.audio = audio;
            propertiesObject.startIndex = this.props.index;
            propertiesObject.endIndex = this.props.index;

            if (!audio.showControlPoint)
                this.props.dispatch(selectElement(audio.uuid, true));

            this.props.dispatch(changeElementPosition(propertiesObject));

            saveManager.isContentChanged(true);
            audioEditorUtils.addActionToHistory();

            this.changeMarkerPosition(newProperties.x);

            if (this.refs.waveform) {
                if (newProperties.inPoint > 0)
                    this.refs.waveform.style.left = -audioEditorUtils.getSlideWidth(newProperties.inPoint) + 'px';
                else
                    this.refs.waveform.style.left = '0px';
            }

            if (this.refs.textElement && this.refs.textElement.style) {
                if (titleWidth > 0)
                    this.refs.textElement.style.display = 'block';
                else
                    this.refs.textElement.style.display = 'none';
            }
        } else {
            if (arrow == 0 || newProperties.updateLeft) { // LEFT arrow
                this.refs.track.style.left = newProperties.x + 'px';

                var inPointPos = this.props.audio.inPoint > 0 ? (- audioEditorUtils.getSlideWidth(this.props.audio.inPoint)) : 0;
                var leftPosition = audioEditorUtils.getItemPosition(this.props.audio.left);

                if (this.refs.waveform)
                    this.refs.waveform.style.left = (inPointPos + leftPosition - newProperties.x) + 'px'
            }

            this.refs.track.style.width = newProperties.width + 'px';
            this.refs.clone.style.width = newProperties.width + 'px';

            if (titleWidth > 0) {
                this.refs.textElement.style.width = titleWidth + 'px';

                if (audioEditorUtils.isControlPointAction)
                    this.refs.textElement.style.display = 'none';
                else
                    this.refs.textElement.style.display = 'block';
            }
            else
                this.refs.textElement.style.display = 'none';

            if (this.state.rightArrowUpdater && arrow == 0) // used only when the left arrow is moved
                this.state.rightArrowUpdater(newProperties.width);
        }

        audioEditorUtils.checkTimelineWidth();

        return newProperties;
    },
    changeMarkerPosition(position) {
        this.props.dispatch(setMarkerPosition(audioEditorUtils.getItemTimePosition(position)));
    },
    getCorrectPosition(xOffset, arrow) {
        var inPoint = this.props.audio.inPoint;
        var outPoint = this.props.audio.outPoint;
        var newInPoint = this.props.audio.inPoint;
        var newOutPoint = this.props.audio.outPoint;

        if (!inPoint) {
            inPoint = 0;
            newInPoint = 0;
        } else
            inPoint = audioEditorUtils.getSlideWidth(inPoint);

        if (!outPoint) {
            outPoint = 0;
            newOutPoint = 0;
        } else
            outPoint = audioEditorUtils.getSlideWidth(outPoint);

        var newX;
        var newWidth;
        var updateLeft = false;

        if (arrow == 0) { // LEFT ARROW
            newX = this.state.startLeftPosition + xOffset

            if (xOffset < 0) { // drag to left
                if (Math.abs(xOffset) > inPoint)
                    newX = newX + (Math.abs(xOffset) - inPoint);

            } else { // drag to right
                if (this.state.startWidth - Math.abs(xOffset) < 2 * properties.ARROW_SIZE)
                    newX = this.state.startLeftPosition + this.state.startWidth - 2 * properties.ARROW_SIZE;
            }

            newWidth = this.state.startWidth + (this.state.startLeftPosition - newX);
            newInPoint = newInPoint - audioEditorUtils.getItemTimePosition(newWidth - this.state.startWidth);

            if (newInPoint < 0.001)
                newInPoint = 0;

            if (newX < 0.001)
                newX = 0;
        } else { // RIGHT ARROW
            newX = this.state.startLeftPosition;
            newWidth = this.state.startWidth + xOffset;

            if (xOffset < 0) { // drag to left
                if (this.state.startWidth - Math.abs(xOffset) < 2 * properties.ARROW_SIZE)
                    newWidth = 2 * properties.ARROW_SIZE;
            } else { // drag to right
                if (Math.abs(xOffset) > outPoint)
                    newWidth = this.state.startWidth + outPoint;
            }

            if (newX < 0.001) {
                newX = 0;

                if (newWidth > this.props.trackWidth)
                    newWidth = this.props.trackWidth;
            }

            newOutPoint = newOutPoint - audioEditorUtils.getItemTimePosition(newWidth - this.state.startWidth);

            if (newOutPoint < 0.001)
                newOutPoint = 0;
        }

        return {x: newX, width: newWidth, inPoint: newInPoint, outPoint: newOutPoint, updateLeft: updateLeft};
    },
    setRightArrowUpdater(updater) {
        this.setState({
            rightArrowUpdater: updater
        });
    },
    getTextWidth(itemWidth, textSize) {
        var textWidth = properties.TITLE_WIDTH;

        if (textSize > textWidth)
            textWidth = textSize;

        var availableWidth = itemWidth - 2 * properties.ARROW_SIZE - 2 * properties.SOUND_GAP - 2 * 5;

        if (textWidth > availableWidth)
            textWidth = availableWidth;

        if (textWidth <= 20)
            textWidth = -1;

        return textWidth;
    },
    componentDidUpdate() {
        var canvasWidth = this.getCanvasWidth();

        if (this.state.canvasWidth != canvasWidth)
            this.drawWaveform();
    },
    useWaveForm() {
        return playController.useWaveForm();
    },
    drawWaveform() {
        var canvas = this.refs.waveform;
        var newCanvasWidth = this.getCanvasWidth();
        var needsRefresh = (this.state.canvasWidth < 0 || this.state.canvasWidth != newCanvasWidth);

        if (!this.useWaveForm() || !canvas || !needsRefresh)
            return;

        if (this.state.canvasWidth > 60000 || newCanvasWidth > 60000)
            return;

        var audioUrl = this.props.audio.hrefBlob && this.props.audio.hrefBlob.length > 0 ? this.props.audio.hrefBlob : this.props.audio.href;
        var  data = audioVolumeUtils.buffers[audioUrl];

        if (data) {
            this.setState({
                canvasWidth: newCanvasWidth
            });

            var x, y, i, n = data.length;
            var width = canvas.width,
                height = canvas.height,
                ctx = canvas.getContext('2d'),
                amp = height / 50,
                colors = ['#ffbfcd', '#e8e9fe', '#fdf0cd', '#bff5de', '#ffcafc', '#e8e5fe', '#fef0fd', '#f4f4e1'];

            ctx.strokeStyle = colors[this.props.index];
            ctx.lineWidth = 6;
            ctx.beginPath();
            ctx.moveTo(0, amp);

            for (i=0; i<n; i++) {
                if (i % 100 == 0) {
                    x = ((i * width) / n);
                    y = ((data[i] * amp) + height / 2);
                    ctx.lineTo(x, y);
                }
            }

            ctx.stroke();
            ctx.closePath();
        } else {
            audioVolumeUtils.callBackDraws[audioUrl] = this.drawWaveform;
        }
    },
    getCanvasWidth() {
        var inPoint = this.props.audio.inPoint > 0 ? audioEditorUtils.getSlideWidth(this.props.audio.inPoint) : 0;
        var outPoint = this.props.audio.outPoint > 0 ? audioEditorUtils.getSlideWidth(this.props.audio.outPoint) : 0;
        var duration = audioEditorUtils.getSlideWidth(this.props.audio.duration);

        return inPoint + duration + outPoint;
    },
    changeElementPosition(type) {
        const offset = 0.5; // seconds
        var properties = {};
        var skip = false;

        properties.audio = Object.assign({}, this.props.audio);

        switch (type) {
            case 'left': { // Left
                properties.endIndex = this.props.index;
                properties.audio.left = this.props.audio.left - offset;

                if (properties.audio.left < 0) {
                    properties.audio.left = 0;
                    skip = true;
                }
                break;
            }
            case 'right': { // Right
                properties.endIndex = this.props.index;
                properties.audio.left = this.props.audio.left + offset;
                break;
            }
            case 'top': { // Top
                properties.endIndex = this.props.index - 1;

                if (properties.endIndex < 0) {
                    properties.endIndex = 0;
                    skip = true;
                }
                break;
            }
            case 'down': { // Down
                properties.endIndex = this.props.index + 1;

                if (properties.endIndex >= this.props.timelinesLength) {
                    properties.endIndex = this.props.timelinesLength - 1;
                    skip = true;
                }
                break;
            }
        }

        if (skip)
            return;

        audioEditorUtils.isControlPointAction = false;
        audioEditorUtils.isVolumeAction = false;
        playController.getOldScrollPosition();

        properties.startIndex = this.props.index;
        properties.isKeyboardAction = true;

        this.props.dispatch(changeElementPosition(properties));

        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkTimelineWidth();

        if (platformDetection.isIOS())
            return;

        setTimeout(function () {
            var audioItem = document.getElementById('audioItemElement_' + this.props.audio.uuid);

            if (audioItem)
                audioItem.focus();
        }.bind(this), 50);
    },
    onKeyDown(e) {
        if (document.activeElement !=  this.refs.track)
            return;

        switch (e.keyCode) {
            case 37: { // Left
                this.changeElementPosition('left');
                break;
            }
            case 39: { // Right
                this.changeElementPosition('right');
                break;
            }
            case 38: { // Top
                this.changeElementPosition('top');
                break;
            }
            case 40: { // Down
                this.changeElementPosition('down');
                break;
            }
            case 13: { // Enter
                this.props.dispatch(selectElement(this.props.audio.uuid, true));
                this.props.dispatch(setMarkerPosition(this.props.audio.left));
                playController.isPreview = true;
                break;
            }
            case 46: { // Delete
                this.props.dispatch(deleteItem(this.props.audio.uuid));
                playController.isPreview = true;
                break;
            }
            case 27: { // Escape
                this.props.dispatch(selectElement());
                playController.isPreview = true;
                break;
            }
        }
    },
    getTrackTitle() {
        if (this.props.trackTitle && this.props.trackTitle.length > 0)
            return this.props.trackTitle;
        else {
            var title = locales.getCaption('track_1', 'other');

            if (title == undefined || title == '' || title.indexOf('other.') != -1)
                title = 'Track ' + (this.props.index + 1);
            else {
                title = title.replace('1', '');
                title = title + (this.props.index + 1);
            }

            return title;
        }
    },
    render() {
        var height = audioToolUtils.timelineHeight();
        var leftPos = audioEditorUtils.getItemPosition(this.props.audio.left);
        var itemWidth = audioEditorUtils.getSlideWidth(this.props.audio.duration);

        var menuStyle = {
            position: 'absolute',
            left: leftPos,
            width: itemWidth,
            height,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none',
            display: 'flex'
        };

        var backgroundColor = audioEditorUtils.getGradient(this.props.index);
        var cloneStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: itemWidth,
            height: height,
            background: backgroundColor,
            cursor: '-webkit-grab',
            overflow: 'hidden',
            display: 'block'
        };

        var title = textSizeUtils.correctRecordingTitle(this.props.audio.title);
        var textWidth = textSizeUtils.getSpanWidth(11, title);
        var titleWidth = this.getTextWidth(itemWidth, textWidth);
        var fontStyle = {
            position: 'absolute',
            fontSize: 11,
            height: 17,
            paddingTop: 3,
            paddingLeft: 5,
            paddingRight: 5,
            width: titleWidth,
            top: height / 2 - 20/2,
            left: properties.ARROW_SIZE + 5,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            cursor: '-webkit-grab',
            color: 'black',
            background: 'white'
        };

        if (titleWidth < 0 || !this.props.audio.showControlPoint || audioEditorUtils.isControlPointAction)
            fontStyle.display = 'none';

        if (!platformDetection.isIOS()) {
            if (audioEditorUtils.animationId && this.props.audio.uuid == audioEditorUtils.animationId && this.refs.track)
                animator.startOpacityAnimation(this.refs.track);
        }

        var lineSize = 2;
        var leftLineStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: lineSize,
            height: height,
            background: backgroundColor
        };

        if (this.props.audio.left != 0 && !this.props.audio.showControlPoint)
            leftLineStyle.background = properties.SLIDE_VIEWER_BACKGROUND;

        var globalPoint;

        if (this.refs.track) {
            var clientBoundingRect = this.refs.track.getBoundingClientRect();
            globalPoint = {x: clientBoundingRect.left, y: clientBoundingRect.top};
        }

        var inPointWidth = this.props.audio.inPoint > 0 ? audioEditorUtils.getSlideWidth(this.props.audio.inPoint) : 0;
        var canvasStyle = {
            position: 'absolute',
            left: - inPointWidth
        };

        var canvasWidth = this.getCanvasWidth();

        if (canvasWidth > 60000)
            canvasStyle.display = 'none';

        var audioId = 'audioItemElement_' + this.props.audio.uuid;
        var ariaLabelValue = this.getTrackTitle() + ' - ' + this.props.audio.title + ' ' + locales.getCaption('clipName', 'other') + ' ' + this.props.audioIndex;

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <button ref='track' id={audioId} aria-label={ariaLabelValue} aria-selected={this.props.audio.showControlPoint} className='audioItemRenderer' style={menuStyle} onKeyDown={this.onKeyDown}>
                    <span ref='clone' style={cloneStyle} id={'clone_' + this.props.audio.uuid}>
                        <canvas ref='waveform' style={canvasStyle} width={canvasWidth} height={cloneStyle.height} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}/>
                        <span ref='textElement' style={fontStyle}>{title}</span>
                    </span>
                    <span style={leftLineStyle}/>
                    <ControlPoint index={0} trackWidth={menuStyle.width} updateSize={this.updateSize} initStateForControlPointKeyHanlder={this.initStateForControlPointKeyHanlder} showControlPoint={this.props.audio.showControlPoint}/>
                    <ControlPoint index={1} trackWidth={menuStyle.width} updateSize={this.updateSize} initStateForControlPointKeyHanlder={this.initStateForControlPointKeyHanlder} showControlPoint={this.props.audio.showControlPoint} setRightArrowUpdater={this.setRightArrowUpdater}/>
                    <AudioGraph audio={this.props.audio} globalPoint={globalPoint} parentId={audioId} isSelected={this.props.audio.showControlPoint}/>
                </button>
            </Draggable>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioItemRenderer.js
 **/